import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface GetResolution886ReportParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetResolution886Report = (params: GetResolution886ReportParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_RESOLUTION_886, params],
		queryFn: async () => Service.show(params),
		enabled: isEnabled
	});
};
